"use client"
import Intro from '@/ui/Intro'
import ImageMarquee from '@/ui/ImageMarquee'

const Ourcollabrators = ({ collaborators = [] }) => {
    return (
        <>
            <div className='page-container'>
                <Intro
                    title="Our Collaborations"
                    description="Partnerships and recognitions that reinforce trust, innovation, and long-term vision."
                />
            </div>
            <ImageMarquee items={collaborators} speedSeconds={200} className="mt-10" />
        </>
    );
};

export default Ourcollabrators;
